import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { goodsPaymentOrder } from '@/api/apis';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  name: "goodsPaymentOrder",
  data: function data() {
    var _this = this;

    return {
      searchModel_1000: {
        "type": "searchTemplate",
        "id": "id_1000",
        "del": false,
        "searchData": [{
          "title": "创建日期",
          "select": 0,
          "type": 1,
          "id": 0,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "children": [{
            "type": "button",
            "title": "全部",
            "field": []
          }, {
            "type": "button",
            "title": "今天",
            "field": []
          }, {
            "type": "button",
            "title": "昨天",
            "field": []
          }, {
            "type": "button",
            "title": "最近7天",
            "field": []
          }, {
            "type": "button",
            "title": "本月",
            "field": []
          }, {
            "type": "button",
            "title": "本年",
            "field": []
          }, {
            "type": "custom-datetime-range",
            "title": "自定义",
            "field": []
          }],
          "remoteFunc": ["modelConditionFunc_0"]
        }, {
          "title": "会员编号",
          "select": 0,
          "type": 2,
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "children": [{
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "buyer.number",
              "value": "",
              "desc": "会员编号"
            }],
            "operator": ["gte", "lte", "gt", "lt", "eq", "ne", "like", "notLike", "in", "between"]
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "store_number",
              "desc": "报单编号"
            }],
            "operator": []
          }, {
            "type": "input-complex",
            "placeholder": "请输入",
            "field": [{
              "key": "direct",
              "desc": "推荐人编号"
            }],
            "operator": []
          }],
          "remoteFunc": []
        }, {
          "title": "支付状态",
          "select": 0,
          "type": 0,
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "children": [{
            "type": "button",
            "title": "全部",
            "field": []
          }, {
            "type": "button",
            "title": "未支付",
            "field": [{
              "key": "status",
              "value": "0"
            }]
          }, {
            "type": "button",
            "title": "已支付",
            "field": [{
              "key": "status",
              "value": "1"
            }]
          }, {
            "type": "button",
            "title": "已取消",
            "total": 0,
            "field": [{
              "key": "status",
              "value": "2"
            }]
          }, {
            "type": "button",
            "title": "已过期",
            "total": 0,
            "field": [{
              "key": "status",
              "value": "3"
            }]
          }],
          "remoteFunc": []
        }, {
          "title": "分账状态",
          "select": 0,
          "type": 0,
          "id": 3,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "children": [{
            "type": "button",
            "title": "全部",
            "field": []
          }, {
            "type": "button",
            "title": "未分账",
            "field": [{
              "key": "split_status",
              "value": "0"
            }]
          }, {
            "type": "button",
            "title": "分账中",
            "field": [{
              "key": "split_status",
              "value": "1"
            }]
          }, {
            "type": "button",
            "title": "已分账",
            "total": 0,
            "field": [{
              "key": "split_status",
              "value": "2"
            }]
          }, {
            "type": "button",
            "title": "分账失败",
            "total": 0,
            "field": [{
              "key": "split_status",
              "value": "3"
            }]
          }],
          "remoteFunc": []
        }, {
          "title": "提现状态",
          "select": 0,
          "type": 0,
          "id": 4,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "children": [{
            "type": "button",
            "title": "全部",
            "field": []
          }, {
            "type": "button",
            "title": "未体现",
            "field": [{
              "key": "withdrawal_status",
              "value": "0"
            }]
          }, {
            "type": "button",
            "title": "提现中",
            "field": [{
              "key": "withdrawal_status",
              "value": "1"
            }]
          }, {
            "type": "button",
            "title": "已提现",
            "total": 0,
            "field": [{
              "key": "withdrawal_status",
              "value": "2"
            }]
          }, {
            "type": "button",
            "title": "提现失败",
            "total": 0,
            "field": [{
              "key": "withdrawal_status",
              "value": "3"
            }]
          }],
          "remoteFunc": []
        }],
        "operateData": [{
          "title": "搜索",
          "type": "primary",
          "tag": "search",
          "icon": "el-icon-search"
        }, {
          "title": "导出",
          "type": "primary",
          "tag": "export",
          "icon": "el-icon-position"
        }],
        "isCollapse": false
      },
      tableModel_1001: {
        "type": "tableTemplate",
        "id": "id_1001",
        "del": false,
        "tableModel": [{
          "label": "会员编号",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "buyer.number"
        }, {
          "label": "推荐人",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "direct"
        }, {
          "label": "报单人",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "store_number"
        }, {
          "label": "商品名称",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "product_name"
        }, {
          "label": "金额",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "amount"
        }, {
          "label": "支付状态",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "select",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "status"
        }, {
          "label": "支付日期",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "paid_at"
        }, {
          "label": "过期日期",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "expire_at"
        }, {
          "label": "分账状态",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "select",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "split_status"
        }, {
          "label": "分账日期",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "split_at"
        }, {
          "label": "分账金额",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "split_amount"
        }, {
          "label": "提现状态",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "select",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "withdrawal_status"
        }, {
          "label": "报单人通联账号",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "store_tl_account"
        }, {
          "label": "备注",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "remark"
        }, {
          "label": "创建日期",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "created_at"
        }, {
          "label": "更新日期",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "updated_at"
        }, {
          "label": "会员姓名",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "payer_name"
        }, {
          "label": "推荐人姓名",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "recommender_name"
        }, {
          "label": "报单人姓名",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "creator_name"
        }, {
          "label": "体现备注",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "withdrawal_remark"
        }],
        "tableSwitchProps": {},
        "tableSelectProps": {
          "status": {
            "multiple": 0,
            "data": [{
              "key": 0,
              "value": "未支付"
            }, {
              "key": 1,
              "value": "已支付"
            }, {
              "key": 2,
              "value": "已取消"
            }, {
              "key": 3,
              "value": "已过期"
            }],
            "remote": false,
            "id": 0,
            "relation": false,
            "relationProps": []
          },
          "withdrawal_status": {
            "multiple": 0,
            "data": [{
              "key": 0,
              "value": "未提现"
            }, {
              "key": 1,
              "value": "提现中"
            }, {
              "key": 2,
              "value": "已提现"
            }, {
              "key": 3,
              "value": "提现失败"
            }],
            "remote": false,
            "id": 1,
            "relation": false,
            "relationProps": []
          },
          "split_status": {
            "multiple": 0,
            "data": [{
              "key": 0,
              "value": "未分账"
            }, {
              "key": 1,
              "value": "分账中"
            }, {
              "key": 2,
              "value": "已分账"
            }, {
              "key": 3,
              "value": "分账失败"
            }],
            "remote": false,
            "id": 2,
            "relation": false,
            "relationProps": []
          }
        },
        "tableCascaderProps": {},
        "tableFileProps": {},
        "rowButton": [],
        "stripe": true,
        "border": true,
        "showPagination": true,
        "showSelection": false,
        "showSummary": false,
        "title": "货款订单",
        "tableName": "",
        "isGroup": false,
        "isTree": false,
        "headerButton": [],
        "tableAutocompleteProps": {},
        "tableRadioProps": {}
      },
      remoteFunc: {
        modelConditionFunc_0: function modelConditionFunc_0(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "created_at",
            value: []
          }], [{
            key: "created_at",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "created_at",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "created_at",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "created_at",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "created_at",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "created_at",
            value: []
          }]];
          resolve(tag, data);
        }
      }
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      goodsPaymentOrder(params).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resolve({
                  total: res.count,
                  data: res.rows
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {//if (isEdit){
      //  params.id = row.id
      //}
      //xxxAdd(params).then(async res=>{
      //  resolve()
      //})
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {//点击列表按钮回调
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {//列表尾部合计回调
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      return true;
    }
  }
};